<mp-filter-group
  [filterName]="bucketsGroup().label"
  [icon]="icon()"
  [searchable]="true"
  [searchFieldPlaceholder]="searchFieldPlaceholder()"
  [(isSearchExpanded)]="isSearchExpanded"
  [(isExpanded)]="isExpanded"
  (isExpandedChange)="onExpandedChange($event)"
  (searchTermChange)="onSearchTermChange($event)"
>
  <mp-filter-badge filter-group-selection-info [value]="bucketSelectedOptionsCount()" />

  @if (bucketSelectedOptionsCount() > 0) {
    <mp-filter-clear-button filter-group-clear-filter-action (clearFilter)="onClearSelection()" />
  }

  @if (bucketsGroup().hasMore) {
    <span class="show-more" (click)="showMoreClick.emit()"> MEHR... </span>
  }

  <mp-multi-selection-filter
    [options]="visibleBucketOptions()"
    [(selectedValues)]="selectedValues"
    (optionSelect)="onOptionSelect($event)"
  />
</mp-filter-group>
